<div class="available-months-operation">
    <span class="time-details">
        <select value="{{ defaultValues.month }}" (change)="onValueChange($event, 'month')">
            <option value="" disabled selected>Select Month</option>
            <option value="all">All Months</option>
            <option value="january">January</option>
            <option value="february">February</option>
            <option value="march">March</option>
            <option value="april">April</option>
            <option value="may">May</option>
            <option value="june">June</option>
            <option value="july">July</option>
            <option value="august">August</option>
            <option value="september">September</option>
            <option value="october">October</option>
            <option value="november">November</option>
            <option value="december">December</option>
        </select>
    </span>
    <span class="time-details">
        <input
            type="time"
            value="{{ defaultValues.openingTime }}"
            (change)="onValueChange($event, 'openingTime')"
        />
    </span>

    <span class="time-details">
        <input
            type="time"
            value="{{ defaultValues.closingTime }}"
            (change)="onValueChange($event, 'closingTime')"
        />
    </span>

    <span class="time-details">
        <input
            type="number"
            placeholder="Order Limit (Optional)"
            value="{{ defaultValues.orderLimit }}"
            (change)="onValueChange($event, 'orderLimit')"
        />
    </span>


</div>
